import { INewbuildingLabel, IOnlineDealSettings, TLabelType } from '../../types/newbuildingLabel';
import { IApplicationState } from '../../types/redux';
import { getNewbuildingId } from './getNewbuildingId';

// В фичеринговой карточке возможны только два типа лейбла - "Онлайн-сделка" и "Застройщик на связи"
// Лейбл "Консультант на связи" не используется
export const getLabelType = (
  newbuildingId: number,
  onlineDealSettings: IOnlineDealSettings[],
  isFromDeveloper: boolean,
): TLabelType | null => {
  let type: TLabelType | null = null;

  if (isFromDeveloper) {
    type = 'builderOnline';
  }

  onlineDealSettings.forEach(regionSettings => {
    if (regionSettings.newBuildingIds.includes(newbuildingId) && isFromDeveloper) {
      type = 'onlineDeal';
    }
  });

  return type;
};

export const getTexts = (newbuildingLabel: INewbuildingLabel, type: TLabelType) => {
  return {
    labelText: newbuildingLabel.indicatorTexts[type],
    tooltipTitle: newbuildingLabel.infoTexts[type].title,
    tooltipText: newbuildingLabel.infoTexts[type].text,
  };
};

export function newbuildingLabelsSelector(state: IApplicationState) {
  const {
    newbuildingLabel,
    newbuilding: { fromDevelopersPropsCount },
  } = state;

  let labels = {
    labelText: '',
    tooltipTitle: '',
    tooltipText: '',
  };

  if (!newbuildingLabel) {
    return labels;
  }

  const isEnabled = newbuildingLabel.isEnabled;
  if (!isEnabled) {
    return labels;
  }

  const isFromDeveloper = Boolean(fromDevelopersPropsCount);
  const newbuildingId = getNewbuildingId(state);

  if (newbuildingId) {
    const type = getLabelType(newbuildingId, newbuildingLabel.onlineDeal, isFromDeveloper);

    if (type) {
      labels = getTexts(newbuildingLabel, type);
    }
  }

  return labels;
}
